"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCookieValue;
function getCookieValue(cname, defaultValue) {
  // `getClientEnvironmentDetails` could provide this information, but imports
  // the "bowser" package to decorate a bunch of details we don't need (that's ~5k minified)
  // As such, we'll just lift the line we actually want:
  // https://github.com/mntv-webplatform/smpackages/blob/master/packages/utils/src/environment/index.ts#L83
  var isBrowser = typeof window === 'object';
  if (!isBrowser) return '';
  var name = "".concat(cname, "=");
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i += 1) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return defaultValue || '';
}
module.exports = exports.default;
//# sourceMappingURL=utils.js.map